import { jsx as o } from "react/jsx-runtime";
import { GradientButton as n } from "../gradient-button/index.js";
import { trackNewChatClick as i } from "../../../../utils/track.js";
import { getChatUrl as l } from "../../../../utils/webapp-chat-url.js";
import { CHAT_REF as s } from "../../../../utils/chat-ref.js";
import u from "./styles.module.less.js";
const w = (t) => {
  const { getTranslation: e, isScrolledHeader: r, language: a, newChatUrl: m } = t;
  return /* @__PURE__ */ o(
    n,
    {
      label: e("pages.chat-now"),
      path: l({
        origin: m,
        language: a,
        newCase: !0,
        ref: s.headerChatNow
      }),
      onClick: () => i("menu"),
      isScrolledHeader: r
    }
  );
}, d = (t) => {
  const { getTranslation: e, language: r, newChatUrl: a } = t;
  return /* @__PURE__ */ o(
    n,
    {
      label: e("pages.chat"),
      path: l({
        origin: a,
        language: r,
        newCase: !0,
        ref: s.headerChatNow
      }),
      onClick: () => i("menu"),
      className: u.mobileMenuGradientButton
    }
  );
};
export {
  w as MenuChatButtonDesktop,
  d as MenuChatButtonMobile
};
